<template>
  <div
    id="post-purchase-container"
    class="grid-container grid-x post-purchase-home small-padding-top-s medium-padding-top-xl small-padding-bottom-xxl medium-padding-bottom-xxxl"
  >
    <LeftNav
      :heading="isMcom ? 'My Account' : ''"
      :no-accordion="isBcom"
      class="show-for-large cell small-12 large-3 padding-right-s xlarge-padding-right-l hide-for-print"
    />
    <div :class="route?.meta?.class">
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import LeftNav from '@nuxt-common/left-nav/app/components/LeftNav.vue';

const { isMcom, isBcom } = useBrand();
const route = useRoute();
</script>
